import React, { useState } from 'react';
import { CalendarState } from '../types';
import type { Todo } from '@ext-bookmark/shared/types';
import type { Holiday } from '../../../services/todo/holidays';

export const useCalendarState = (
  externalSelectedDate?: Date | null,
  userId?: string | null
): {
  state: CalendarState;
  setCurrentDate: (date: Date) => void;
  setInternalSelectedDate: (date: Date | null) => void;
  setMonthTodos: React.Dispatch<React.SetStateAction<Map<string, Todo[]>>>;
  setHolidays: (holidays: Map<string, Holiday>) => void;
  selectedDate: Date | null;
} => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [internalSelectedDate, setInternalSelectedDate] = useState<Date | null>(null);
  const [monthTodos, setMonthTodos] = useState<Map<string, Todo[]>>(new Map());
  const [holidays, setHolidays] = useState<Map<string, Holiday>>(new Map());
  
  // 使用外部传入的 selectedDate，如果没有则使用内部的
  const selectedDate = externalSelectedDate !== undefined ? externalSelectedDate : internalSelectedDate;
  
  // 使用外部传入的 userId，避免重复请求
  const currentUserId = userId || null;

  const state: CalendarState = {
    currentDate,
    selectedDate,
    monthTodos,
    holidays,
    currentUserId,
  };

  return {
    state,
    setCurrentDate,
    setInternalSelectedDate,
    setMonthTodos,
    setHolidays,
    selectedDate,
  };
};
